import GalleryMenuItem from './gallery-menu-item';
import { useEffect } from 'react';
import { getAllAlbums } from '../../data/gallery-data-service';
import AddAlbum from '../album/actions/album-add';
import { IGalleryAlbum } from '../../gallery-interfaces';
import { createAlbumsTree } from '../../domain/gallery-provider';
import { closeMobileMenu } from '../../../../menu/ui/mobile-menu-provider';
import { NavLink } from 'react-router-dom';
import { useGalleryStore } from '../../data/gallery-store';

const GalleryMenu = () => {

    const galleryAlbums = useGalleryStore(store => store.galleryAlbums);
    const setGalleryAlbums = useGalleryStore(store => store.setGalleryAlbums);

    useEffect(() => {
        (async () => {
            const response = await getAllAlbums() as IGalleryAlbum[];
            if(!response) return;
            setGalleryAlbums(createAlbumsTree(response));
        })();
    }, [setGalleryAlbums]);

    return (
        <div className="side-menu flex flex-col xl:w-[350px] bg-slate-800 text-slate-100 leading-7 h-screen color-scheme-dark">
            <div className="overflow-auto p-3">
                <div className="pb-3 pt-3 flex items-center">

                    <NavLink
                        to={ `/gallery` }
                        end={ true }
                        className="gallery__menu-item__title text-left flex-1"
                        onClick={ closeMobileMenu }>
                        Root ({ galleryAlbums.length || 0 })
                    </NavLink>

                    {/*<div className="flex items-center ml-auto">
                        <AddAlbum />
                    </div>*/}
                </div>

                {
                    galleryAlbums.map((album, index) => {
                        return (
                            <GalleryMenuItem
                                key={ album.album_id }
                                album={ album }
                                isLast={ index === galleryAlbums.length - 1 }
                            />
                        )
                    })
                }

                <AddAlbum />
            </div>
        </div>
    )
};

export default GalleryMenu;